<div class="kontakt-belka-boczna p-4">
  <mm-przycisk-ikona
    class="przycisk-zamknij"
    typ="przezroczysty"
    ikona="lewa_strzalka"
    (click)="zamknijKontakt()">
  </mm-przycisk-ikona>
  <mm-kontakt-formularz (poWyslaniu)="zamknijKontakt()"></mm-kontakt-formularz>
</div>

